import React, {useState, useCallback} from 'react'
import {useTranslation} from 'react-i18next';
import {TemplateSchema} from '../../../../api/DBSchema/Template';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import SMCTextArea from '../../../../components/Simple/SMCTextArea';
import {hasValue} from '../../../../utils/utils';
import SMCFileInput from '../../../../components/Simple/SMCFileInput';
import {readFileContent} from '../../../../utils/utils';
import SMCButton from '../../../../components/Simple/SMCButton';

function EditTab({
    templateObject,
    setTemplateObjectValue,
    editShortBody
}) {
    const { t } = useTranslation();

    const messageData = templateObject[TemplateSchema.messageData];
    const messageDataSchema = TemplateSchema.messageDataSchema;
    const messageSubject   = messageData[messageDataSchema.subject];
    const messageBcc       = messageData[messageDataSchema.bcc];
    const messageTo        = messageData[messageDataSchema.to];
    const messageBody      = messageData[messageDataSchema.body];
    const messageShortBody = messageData[messageDataSchema.shortBody];

    const currentlyEditedBody     = editShortBody ? messageShortBody            : messageBody;
    const currentlyEditedBodyName = editShortBody ? messageDataSchema.shortBody : messageDataSchema.body;
    
    const [uploadedFile, setUploadedFile] = useState();

    const copyUploadedFileToContent = useCallback(() => {
        if (uploadedFile) {
            const fileSuffix = uploadedFile.name.split('.').pop();
            if (fileSuffix !== 'txt' && fileSuffix !== 'htm' && fileSuffix !== 'html') {
                alert(t('com.sofaware.db.SETTINGS_NOTIFICATIONS_BAD_FILE'));
            }
            else {
                readFileContent(uploadedFile)
                    .then(content => setTemplateObjectValue([TemplateSchema.messageData, currentlyEditedBodyName], content))
                    .catch(console.log);
            }
        }
    }, [setTemplateObjectValue, currentlyEditedBodyName, uploadedFile, t]);

    return (
        <div style={{ width: '100%' }}>
            <SMCTextInput
                value={messageSubject}
                onChange={e => setTemplateObjectValue([TemplateSchema.messageData, messageDataSchema.subject], e.target.value)}
                label={t('SMC_MESSEGE_SUBJECT')}
                labelWidth={80}
                width={600}
            />
            {
                hasValue(messageTo) && (
                    <SMCTextInput
                        value={messageTo}
                        onChange={e => setTemplateObjectValue([TemplateSchema.messageData, messageDataSchema.to], e.target.value)}
                        label={t('SMC_MESSEGE_TO')}
                        labelWidth={80}
                        width={600}
                    />
                )
            }
            <SMCTextInput
                value={messageBcc}
                onChange={e => setTemplateObjectValue([TemplateSchema.messageData, messageDataSchema.bcc], e.target.value)}
                label={t('SMC_MESSEGE_BCC')}
                labelWidth={80}
                width={600}
            />
            <SMCTextArea
                value={currentlyEditedBody}
                onChange={e => setTemplateObjectValue([TemplateSchema.messageData, currentlyEditedBodyName], e.target.value)}
                label={t('SMC_MESSEGE_CONTENT')}
                labelWidth={80}
                height={300}
                width={600}
            />
            <SMCFileInput
                inline
                accept=".txt,.html,.htm"
                label={t('SMC_MESSEGE_FILE')}
                labelWidth={80}
                onChange={fileList => {
                    if (fileList && fileList.length) {
                        setUploadedFile(fileList[0]);
                    } else {
                        setUploadedFile(undefined);
                    }
                }}
            />
            <SMCButton style={{ float: 'right', marginRight: '22px' }} onClick={copyUploadedFileToContent}>{t('SMC_MESSEGE_FILE_LOAD')}</SMCButton>
        </div>
    );
}

export default EditTab;